import {
    Icon, IconButton, LinearProgress, Paper,
    Table, TableBody, TableCell, TableContainer, TableFooter,
    TableHead, TableRow, Box,
    useTheme,
    Typography,
    tableCellClasses,
    Collapse,
    Card,
    CardActionArea,
    CardContent,
    CardActions,
    IconButtonProps,
    Button
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDeDetalhe } from "../../shered/components";
import { Enviroment } from "../../shered/enviroments";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DisputaService, IDadosCriteriosDesempate, IDadosEscalacaoOriginao, IDadosEstatistica, IDadosEstatisticaJogadoresPosicao, IDadosFranquia, IGridColumnHeaderParamsStats, IListagemDisputa } from "../../shered/services/api/disputa/DisputaService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { DataGrid, GridColDef, GridExpandMoreIcon } from "@mui/x-data-grid";
import { IDadosJogosNba, IDadosRetornoJogosNba, LigaService } from "../../shered/services/api/liga/LigaService";
import { IDadosJogosRodadaNba, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { Loading } from "../../shered/components/loading/Loading";
import { styled } from '@mui/material/styles';
import { IDadosEstatisticas, IDadosEstatisticasJogo, JogadorService } from "../../shered/services/api/jogador/JogadorService";

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const columnsCriterioDesempate: GridColDef[] = [
    // { field: 'codigo', headerName: 'ID', width: 90, headerClassName: 'super-app-theme--header', },
    {
        field: 'ordem',
        headerName: 'ORDEM',
        headerClassName: 'super-app-theme--header',
        width: UtilidadeService.isMobile() ? 70 : 150,
        editable: false
    },
    {
        field: 'nome',
        headerName: 'NOME',
        editable: false,
        flex: 1,
        headerClassName: 'super-app-theme--header',
        minWidth: UtilidadeService.isMobile() ? 100 : 150,
    },
    {
        field: 'descricao',
        headerName: 'DESCRIÇÃO',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 100 : 150,
    },


];

export const ListagemDeDisputaPontuacaoPlayOffs: React.FC = () => {
    const theme = useTheme();
    const [searchParams, SetSearchParams] = useSearchParams();
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { id } = useParams<"id">();
    const { isAuthenticated, logout } = useAuthContext();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [rowsMandante, setRowsMandante] = useState<IDadosFranquia[]>([]);
    const [rowsVisitante, setRowsVisitante] = useState<IDadosFranquia[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [redirecionar, setRedirecionar] = useState("0");
    const [numeroRodada, setNumeroRodada] = useState(0);
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [franquiaMandante, setFranquiaMandante] = useState<IDadosFranquia>();
    const [franquiaVisitante, setFranquiaVisitante] = useState<IDadosFranquia>();
    const [lstCriteriosDesempate, setLstCriteriosDesempate] = useState<IDadosCriteriosDesempate[]>([]);
    const [nomeFranquiaMandante, setNomeFranquiaMandante] = useState("MANDANTE");
    const [nomeFranquiaVisitante, setNomeFranquiaVisitante] = useState("VISITANTE");
    const [removeLoading, setRemoveLoading] = useState(false);
    const [jogadoresFranquiaMandante, setJogadoresFranquiaMandante] = useState<IDadosEstatistica[]>([]);
    const [jogadoresFranquiaVisitante, setJogadoresFranquiaVisitante] = useState<IDadosEstatistica[]>([]);

    const [placarMandante, setPlacarMandante] = useState(0);
    const [placarVisitante, setPlacarVisitante] = useState(0);
    const [codigoTipoPosicaoConfronto, setCodigoTipoPosicaoConfronto] = useState(0);
    const [listaStatsHeader, setListaStatsHeader] = useState<IGridColumnHeaderParamsStats[]>([]);
    const [lstJogosRodadaNba, setLstJogosRodadaNba] = useState<IDadosJogosNba[]>([]);

    const [vencedorMandante, setVencedorMandante] = useState(false);
    const [vencedorVisitante, setVencedorVisitante] = useState(false);
    const [empate, setEmpate] = useState(false);
    const [statusJogo, setStatusJogo] = useState(false);

    const [porResFgmpMan, setPorResFgmpMan] = useState(0);
    const [porResTreeMan, setPorResTreeMan] = useState(0);
    const [porResFtmpMan, setPorResFtmpMan] = useState(0);

    const [porResFgmpVis, setPorResFgmpVis] = useState(0);
    const [porResTreeVis, setPorResTreeVis] = useState(0);
    const [porResFtmpVis, setPorResFtmpVis] = useState(0);

    const [fgm_Mandante, setFgm_Mandante] = useState(0);
    const [ftm_Mandante, setFtm_Mandante] = useState(0);
    const [threepm_Mandante, setThreepm_Mandante] = useState(0);
    const [pts_Mandante, setPts_Mandante] = useState(0);
    const [reb_Mandante, setReb_Mandante] = useState(0);
    const [oreb_Mandante, setOreb_Mandante] = useState(0);
    const [dreb_Mandante, setDreb_Mandante] = useState(0);
    const [ast_Mandante, setAst_Mandante] = useState(0);
    const [stl_Mandante, setStl_Mandante] = useState(0);
    const [blk_Mandante, setBlk_Mandante] = useState(0);
    const [to_Mandante, setTo_Mandante] = useState(0);
    const [pf_Mandante, setPf_Mandante] = useState(0);
    const [mplu_Mandante, setMplu_Mandante] = useState(0);
    const [fgmp_Mandante, setFgmp_Mandante] = useState(0);
    const [ftmp_Mandante, setFtmp_Mandante] = useState(0);
    const [threepmp_Mandante, setThreepmp_Mandante] = useState(0);
    const [setimoHome_Mandante, setSetimoHome_Mandante] = useState(0);
    const [setimoHome_Visitante, setSetimoHome_Visitante] = useState(0);

    const [lance_Livre_Errados_Mandante, setLance_Livre_Errados_Mandante] = useState(0);
    const [arremessos_Errados_Mandante, setArremessos_Errados_Mandante] = useState(0);
    const [tres_Pontos_Errados_Mandante, setTres_Pontos_Errados_Mandante] = useState(0);
    const [stocks_Mandante, setStocks_Mandante] = useState(0);
    const [dadosEstatisticasJogo, setDadosEstatisticasJogo] = useState<IDadosEstatisticasJogo>();
    const [estatisticasMandanteRows, setEstatisticasMandanteRows] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows, setEstatisticasVisitanteRows] = useState<IDadosEstatisticas[]>([]);
    const [pesoTotalMandante, setPesoTotalMandante] = useState(0);
    const [pesoTotalVisitante, setPesoTotalVisitante] = useState(0);

    //#region vairaveis
    const [totalCountJogadoresMandante, setTotalCountJogadoresMandante] = useState(0);
    const [totalCountJogadoresVisitante, setTotalCountJogadoresVisitante] = useState(0);
    const [expanded0, setExpanded0] = React.useState(false);
    const [expanded1, setExpanded1] = React.useState(false);
    const [expanded2, setExpanded2] = React.useState(false);
    const [expanded3, setExpanded3] = React.useState(false);
    const [expanded4, setExpanded4] = React.useState(false);
    const [expanded5, setExpanded5] = React.useState(false);
    const [expanded6, setExpanded6] = React.useState(false);
    const [expanded7, setExpanded7] = React.useState(false);
    const [expanded8, setExpanded8] = React.useState(false);
    const [expanded9, setExpanded9] = React.useState(false);
    const [expanded10, setExpanded10] = React.useState(false);
    const [expanded11, setExpanded11] = React.useState(false);
    const [expanded12, setExpanded12] = React.useState(false);
    const [expanded13, setExpanded13] = React.useState(false);
    const [expanded14, setExpanded14] = React.useState(false);
    const [expanded15, setExpanded15] = React.useState(false);
    const [expanded16, setExpanded16] = React.useState(false);
    const [expanded17, setExpanded17] = React.useState(false);
    const [expanded18, setExpanded18] = React.useState(false);
    const [expanded19, setExpanded19] = React.useState(false);
    const [expanded20, setExpanded20] = React.useState(false);
    const [expanded21, setExpanded21] = React.useState(false);
    const [expanded22, setExpanded22] = React.useState(false);
    const [expanded23, setExpanded23] = React.useState(false);
    const [expanded24, setExpanded24] = React.useState(false);
    const [expanded25, setExpanded25] = React.useState(false);
    const [expanded26, setExpanded26] = React.useState(false);
    const [expanded27, setExpanded27] = React.useState(false);
    const [expanded28, setExpanded28] = React.useState(false);
    const [expanded29, setExpanded29] = React.useState(false);
    const [expanded30, setExpanded30] = React.useState(false);
    const [expanded31, setExpanded31] = React.useState(false);
    const [expanded32, setExpanded32] = React.useState(false);
    const [expanded33, setExpanded33] = React.useState(false);
    const [expanded34, setExpanded34] = React.useState(false);
    const [expanded35, setExpanded35] = React.useState(false);
    const [expanded36, setExpanded36] = React.useState(false);
    const [expanded37, setExpanded37] = React.useState(false);
    const [expanded38, setExpanded38] = React.useState(false);
    const [expanded39, setExpanded39] = React.useState(false);

    const [estatisticasMandanteRows0, setEstatisticasMandanteRows0] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows0, setEstatisticasVisitanteRows0] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante0, setTotalCountJogadoresMandante0] = useState(0);
    const [totalCountJogadoresVisitante0, setTotalCountJogadoresVisitante0] = useState(0);
    const [estatisticasMandanteRows1, setEstatisticasMandanteRows1] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows1, setEstatisticasVisitanteRows1] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante1, setTotalCountJogadoresMandante1] = useState(0);
    const [totalCountJogadoresVisitante1, setTotalCountJogadoresVisitante1] = useState(0);
    const [estatisticasMandanteRows2, setEstatisticasMandanteRows2] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows2, setEstatisticasVisitanteRows2] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante2, setTotalCountJogadoresMandante2] = useState(0);
    const [totalCountJogadoresVisitante2, setTotalCountJogadoresVisitante2] = useState(0);
    const [estatisticasMandanteRows3, setEstatisticasMandanteRows3] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows3, setEstatisticasVisitanteRows3] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante3, setTotalCountJogadoresMandante3] = useState(0);
    const [totalCountJogadoresVisitante3, setTotalCountJogadoresVisitante3] = useState(0);
    const [estatisticasMandanteRows4, setEstatisticasMandanteRows4] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows4, setEstatisticasVisitanteRows4] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante4, setTotalCountJogadoresMandante4] = useState(0);
    const [totalCountJogadoresVisitante4, setTotalCountJogadoresVisitante4] = useState(0);
    const [estatisticasMandanteRows5, setEstatisticasMandanteRows5] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows5, setEstatisticasVisitanteRows5] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante5, setTotalCountJogadoresMandante5] = useState(0);
    const [totalCountJogadoresVisitante5, setTotalCountJogadoresVisitante5] = useState(0);
    const [estatisticasMandanteRows6, setEstatisticasMandanteRows6] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows6, setEstatisticasVisitanteRows6] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante6, setTotalCountJogadoresMandante6] = useState(0);
    const [totalCountJogadoresVisitante6, setTotalCountJogadoresVisitante6] = useState(0);
    const [estatisticasMandanteRows7, setEstatisticasMandanteRows7] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows7, setEstatisticasVisitanteRows7] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante7, setTotalCountJogadoresMandante7] = useState(0);
    const [totalCountJogadoresVisitante7, setTotalCountJogadoresVisitante7] = useState(0);
    const [estatisticasMandanteRows8, setEstatisticasMandanteRows8] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows8, setEstatisticasVisitanteRows8] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante8, setTotalCountJogadoresMandante8] = useState(0);
    const [totalCountJogadoresVisitante8, setTotalCountJogadoresVisitante8] = useState(0);
    const [estatisticasMandanteRows9, setEstatisticasMandanteRows9] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows9, setEstatisticasVisitanteRows9] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante9, setTotalCountJogadoresMandante9] = useState(0);
    const [totalCountJogadoresVisitante9, setTotalCountJogadoresVisitante9] = useState(0);
    const [estatisticasMandanteRows10, setEstatisticasMandanteRows10] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows10, setEstatisticasVisitanteRows10] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante10, setTotalCountJogadoresMandante10] = useState(0);
    const [totalCountJogadoresVisitante10, setTotalCountJogadoresVisitante10] = useState(0);
    const [estatisticasMandanteRows11, setEstatisticasMandanteRows11] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows11, setEstatisticasVisitanteRows11] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante11, setTotalCountJogadoresMandante11] = useState(0);
    const [totalCountJogadoresVisitante11, setTotalCountJogadoresVisitante11] = useState(0);
    const [estatisticasMandanteRows12, setEstatisticasMandanteRows12] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows12, setEstatisticasVisitanteRows12] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante12, setTotalCountJogadoresMandante12] = useState(0);
    const [totalCountJogadoresVisitante12, setTotalCountJogadoresVisitante12] = useState(0);
    const [estatisticasMandanteRows13, setEstatisticasMandanteRows13] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows13, setEstatisticasVisitanteRows13] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante13, setTotalCountJogadoresMandante13] = useState(0);
    const [totalCountJogadoresVisitante13, setTotalCountJogadoresVisitante13] = useState(0);
    const [estatisticasMandanteRows14, setEstatisticasMandanteRows14] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows14, setEstatisticasVisitanteRows14] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante14, setTotalCountJogadoresMandante14] = useState(0);
    const [totalCountJogadoresVisitante14, setTotalCountJogadoresVisitante14] = useState(0);
    const [estatisticasMandanteRows15, setEstatisticasMandanteRows15] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows15, setEstatisticasVisitanteRows15] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante15, setTotalCountJogadoresMandante15] = useState(0);
    const [totalCountJogadoresVisitante15, setTotalCountJogadoresVisitante15] = useState(0);
    const [estatisticasMandanteRows16, setEstatisticasMandanteRows16] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows16, setEstatisticasVisitanteRows16] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante16, setTotalCountJogadoresMandante16] = useState(0);
    const [totalCountJogadoresVisitante16, setTotalCountJogadoresVisitante16] = useState(0);
    const [estatisticasMandanteRows17, setEstatisticasMandanteRows17] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows17, setEstatisticasVisitanteRows17] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante17, setTotalCountJogadoresMandante17] = useState(0);
    const [totalCountJogadoresVisitante17, setTotalCountJogadoresVisitante17] = useState(0);
    const [estatisticasMandanteRows18, setEstatisticasMandanteRows18] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows18, setEstatisticasVisitanteRows18] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante18, setTotalCountJogadoresMandante18] = useState(0);
    const [totalCountJogadoresVisitante18, setTotalCountJogadoresVisitante18] = useState(0);
    const [estatisticasMandanteRows19, setEstatisticasMandanteRows19] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows19, setEstatisticasVisitanteRows19] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante19, setTotalCountJogadoresMandante19] = useState(0);
    const [totalCountJogadoresVisitante19, setTotalCountJogadoresVisitante19] = useState(0);
    const [estatisticasMandanteRows20, setEstatisticasMandanteRows20] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows20, setEstatisticasVisitanteRows20] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante20, setTotalCountJogadoresMandante20] = useState(0);
    const [totalCountJogadoresVisitante20, setTotalCountJogadoresVisitante20] = useState(0);
    const [estatisticasMandanteRows21, setEstatisticasMandanteRows21] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows21, setEstatisticasVisitanteRows21] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante21, setTotalCountJogadoresMandante21] = useState(0);
    const [totalCountJogadoresVisitante21, setTotalCountJogadoresVisitante21] = useState(0);
    const [estatisticasMandanteRows22, setEstatisticasMandanteRows22] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows22, setEstatisticasVisitanteRows22] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante22, setTotalCountJogadoresMandante22] = useState(0);
    const [totalCountJogadoresVisitante22, setTotalCountJogadoresVisitante22] = useState(0);
    const [estatisticasMandanteRows23, setEstatisticasMandanteRows23] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows23, setEstatisticasVisitanteRows23] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante23, setTotalCountJogadoresMandante23] = useState(0);
    const [totalCountJogadoresVisitante23, setTotalCountJogadoresVisitante23] = useState(0);
    const [estatisticasMandanteRows24, setEstatisticasMandanteRows24] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows24, setEstatisticasVisitanteRows24] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante24, setTotalCountJogadoresMandante24] = useState(0);
    const [totalCountJogadoresVisitante24, setTotalCountJogadoresVisitante24] = useState(0);
    const [estatisticasMandanteRows25, setEstatisticasMandanteRows25] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows25, setEstatisticasVisitanteRows25] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante25, setTotalCountJogadoresMandante25] = useState(0);
    const [totalCountJogadoresVisitante25, setTotalCountJogadoresVisitante25] = useState(0);
    const [estatisticasMandanteRows26, setEstatisticasMandanteRows26] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows26, setEstatisticasVisitanteRows26] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante26, setTotalCountJogadoresMandante26] = useState(0);
    const [totalCountJogadoresVisitante26, setTotalCountJogadoresVisitante26] = useState(0);
    const [estatisticasMandanteRows27, setEstatisticasMandanteRows27] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows27, setEstatisticasVisitanteRows27] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante27, setTotalCountJogadoresMandante27] = useState(0);
    const [totalCountJogadoresVisitante27, setTotalCountJogadoresVisitante27] = useState(0);
    const [estatisticasMandanteRows28, setEstatisticasMandanteRows28] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows28, setEstatisticasVisitanteRows28] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante28, setTotalCountJogadoresMandante28] = useState(0);
    const [totalCountJogadoresVisitante28, setTotalCountJogadoresVisitante28] = useState(0);
    const [estatisticasMandanteRows29, setEstatisticasMandanteRows29] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows29, setEstatisticasVisitanteRows29] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante29, setTotalCountJogadoresMandante29] = useState(0);
    const [totalCountJogadoresVisitante29, setTotalCountJogadoresVisitante29] = useState(0);
    const [estatisticasMandanteRows30, setEstatisticasMandanteRows30] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows30, setEstatisticasVisitanteRows30] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante30, setTotalCountJogadoresMandante30] = useState(0);
    const [totalCountJogadoresVisitante30, setTotalCountJogadoresVisitante30] = useState(0);
    const [estatisticasMandanteRows31, setEstatisticasMandanteRows31] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows31, setEstatisticasVisitanteRows31] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante31, setTotalCountJogadoresMandante31] = useState(0);
    const [totalCountJogadoresVisitante31, setTotalCountJogadoresVisitante31] = useState(0);
    const [estatisticasMandanteRows32, setEstatisticasMandanteRows32] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows32, setEstatisticasVisitanteRows32] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante32, setTotalCountJogadoresMandante32] = useState(0);
    const [totalCountJogadoresVisitante32, setTotalCountJogadoresVisitante32] = useState(0);
    const [estatisticasMandanteRows33, setEstatisticasMandanteRows33] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows33, setEstatisticasVisitanteRows33] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante33, setTotalCountJogadoresMandante33] = useState(0);
    const [totalCountJogadoresVisitante33, setTotalCountJogadoresVisitante33] = useState(0);
    const [estatisticasMandanteRows34, setEstatisticasMandanteRows34] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows34, setEstatisticasVisitanteRows34] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante34, setTotalCountJogadoresMandante34] = useState(0);
    const [totalCountJogadoresVisitante34, setTotalCountJogadoresVisitante34] = useState(0);
    const [estatisticasMandanteRows35, setEstatisticasMandanteRows35] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows35, setEstatisticasVisitanteRows35] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante35, setTotalCountJogadoresMandante35] = useState(0);
    const [totalCountJogadoresVisitante35, setTotalCountJogadoresVisitante35] = useState(0);
    const [estatisticasMandanteRows36, setEstatisticasMandanteRows36] = useState<IDadosEstatisticas[]>([]);
    const [estatisticasVisitanteRows36, setEstatisticasVisitanteRows36] = useState<IDadosEstatisticas[]>([]);
    const [totalCountJogadoresMandante36, setTotalCountJogadoresMandante36] = useState(0);
    const [totalCountJogadoresVisitante36, setTotalCountJogadoresVisitante36] = useState(0);

    //#endregion

    const [fgm_Visitante, setFgm_Visitante] = useState(0);
    const [ftm_Visitante, setFtm_Visitante] = useState(0);
    const [threepm_Visitante, setThreepm_Visitante] = useState(0);
    const [pts_Visitante, setPts_Visitante] = useState(0);
    const [reb_Visitante, setReb_Visitante] = useState(0);
    const [oreb_Visitante, setOreb_Visitante] = useState(0);
    const [dreb_Visitante, setDreb_Visitante] = useState(0);
    const [ast_Visitante, setAst_Visitante] = useState(0);
    const [stl_Visitante, setStl_Visitante] = useState(0);
    const [blk_Visitante, setBlk_Visitante] = useState(0);
    const [to_Visitante, setTo_Visitante] = useState(0);
    const [pf_Visitante, setPf_Visitante] = useState(0);
    const [mplu_Visitante, setMplu_Visitante] = useState(0);
    const [lance_Livre_Errados_Visitante, setLance_Livre_Errados_Visitante] = useState(0);
    const [arremessos_Errados_Visitante, setArremessos_Errados_Visitante] = useState(0);
    const [tres_Pontos_Errados_Visitante, setTres_Pontos_Errados_Visitante] = useState(0);
    const [stocks_Visitante, setStocks_Visitante] = useState(0);

    const [totalMandantePG, setTotalMandantePG] = useState(0);
    const [totalVisitantePG, setTotalVisitantePG] = useState(0);
    
    const [totalMandanteSG, setTotalMandanteSG] = useState(0);
    const [totalVisitanteSG, setTotalVisitanteSG] = useState(0);
    
    const [totalMandanteSF, setTotalMandanteSF] = useState(0);
    const [totalVisitanteSF, setTotalVisitanteSF] = useState(0);
    
    const [totalMandantePF, setTotalMandantePF] = useState(0);
    const [totalVisitantePF, setTotalVisitantePF] = useState(0);
    
    const [totalMandanteC, setTotalMandanteC] = useState(0);
    const [totalVisitanteC, setTotalVisitanteC] = useState(0);

    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const busca = useMemo(() => {
        return searchParams.get("busca") || "";
    }, [searchParams]);

    const paginaMandante = useMemo(() => {
        return Number(searchParams.get("paginamandante") || "0");
    }, [searchParams]);

    const paginaVisitante = useMemo(() => {
        return Number(searchParams.get("paginavisitante") || "0");
    }, [searchParams]);

    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });

            setRedirecionar("/dashboard");
            return;
        }
        debounce(() => {
            UtilidadeService.getStatsLigaPorCodigoLiga(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const lstStats = result.data.dado;
                    let lst = lstStats.map((m) => ({
                        codigo: m.codigo,
                        stats: m.nome,
                        descricao: m.descricao !== undefined ? m.descricao : ""
                    }));
                    setListaStatsHeader(lst);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });

            if (id !== undefined) {

                const resultCrypt = UtilidadeService.decrypt(id);
                if (resultCrypt === "" || resultCrypt === undefined) {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    setIsLoading(false);

                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Dados inválidos! ",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;

                }
                let parametros1 = resultCrypt === undefined ? setRedirecionar("/dashboard") : resultCrypt.split("/")[0];
                let parametros2 = resultCrypt === undefined ? setRedirecionar("/dashboard") : resultCrypt.split("/")[1];
                let parametros3 = resultCrypt === undefined ? setRedirecionar("/dashboard") : resultCrypt.split("/")[2];
                let newListaV: IDadosEstatistica[] = [];
                let newListaM: IDadosEstatistica[] = [];
                DisputaService.getEscalacaoDisputasPorCodigoCalendarioPontuacaoPlayOffs(Number(parametros1))
                    .then((result) => {
                        setIsLoading(false);
                        const objResult = result.dado;
                      
                        setFranquiaMandante(objResult.franquia_Mandante);
                        setPlacarMandante(objResult.placar_Mandante ?? 0);
                        setPlacarVisitante(objResult.placar_Visitante ?? 0);
                        newListaM = objResult.estatistica_Jogadores_Franquia_Mandante;
                        setJogadoresFranquiaMandante(objResult.estatistica_Jogadores_Franquia_Mandante);
                        newListaV = objResult.estatistica_Jogadores_Franquia_Visitante;
                        setJogadoresFranquiaVisitante(objResult.estatistica_Jogadores_Franquia_Visitante);
                        setFranquiaVisitante(objResult.franquia_Visitante);
                        setLstCriteriosDesempate(objResult.criterio_Desempate);
                        setCodigoTipoPosicaoConfronto(objResult.codigo_Tipo_Posicao_Confronto);

                        setTotalMandantePG(newListaM.reduce((s, obj) => { return s + (obj.minutos_PG !== undefined ? obj.minutos_PG : 0) }, 0));
                        setTotalVisitantePG(newListaV.reduce((s, obj) => { return s + (obj.minutos_PG !== undefined ? obj.minutos_PG : 0) }, 0));

                        setTotalMandanteSG(newListaM.reduce((s, obj) => { return s + (obj.minutos_SG !== undefined ? obj.minutos_SG : 0) }, 0));
                        setTotalVisitanteSG(newListaV.reduce((s, obj) => { return s + (obj.minutos_SG !== undefined ? obj.minutos_SG : 0) }, 0));

                        setTotalMandanteSF(newListaM.reduce((s, obj) => { return s + (obj.minutos_SF !== undefined ? obj.minutos_SF : 0) }, 0));
                        setTotalVisitanteSF(newListaV.reduce((s, obj) => { return s + (obj.minutos_SF !== undefined ? obj.minutos_SF : 0) }, 0));

                        setTotalMandantePF(newListaM.reduce((s, obj) => { return s + (obj.minutos_PF !== undefined ? obj.minutos_PF : 0) }, 0));
                        setTotalVisitantePF(newListaV.reduce((s, obj) => { return s + (obj.minutos_PF !== undefined ? obj.minutos_PF : 0) }, 0));

                        setTotalMandanteC(newListaM.reduce((s, obj) => { return s + (obj.minutos_C !== undefined ? obj.minutos_C : 0) }, 0));
                        setTotalVisitanteC(newListaV.reduce((s, obj) => { return s + (obj.minutos_C !== undefined ? obj.minutos_C : 0) }, 0));

                        setPesoTotalMandante(newListaM.reduce((s, obj) => { return s + (obj.peso_Total_Jogador !== undefined ? obj.peso_Total_Jogador : 0) }, 0));
                        setPesoTotalVisitante(newListaV.reduce((s, obj) => { return s + (obj.peso_Total_Jogador !== undefined ? obj.peso_Total_Jogador : 0) }, 0));
                        setRemoveLoading(true);
                    })
                    .catch((errors) => {
                        setIsLoading(false);
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModal({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                        }

                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });

                //LigaService.getJogosNBAPorLigaTemporadaRodada(Number(codigoLiga), Number(parametros2), Number(parametros3), Number(parametros1))
                LigaService.getJogosNBAPorLigaTemporadaPlayOffs(Number(parametros1))
                    .then((result) => {
                        setIsLoading(false);
                        const lst = result.dado;
                        let filterList = lst.filter(e => { return e !== null });
                        setLstJogosRodadaNba(filterList);
                    })
                    .catch((errors) => {
                        setIsLoading(false);
                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response !== undefined && errors.response.data.mensagem !== undefined ? errors.response.data.mensagem : "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });
            }
        })
    }, [paginaMandante, paginaVisitante, busca, numeroRodada]);

    const columns: GridColDef[] = [
        {
            field: 'posicao',
            headerName: 'POSIÇÃO',
            headerClassName: 'super-app-theme--header',
            flex: 0.6,
            editable: false,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ? <span style={{ backgroundColor: "red" }}>{params.value}</span> : null,
        },
        {
            field: 'foto',
            headerName: 'FOTO',
            editable: false,
            renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ? <img src={params.value} width={50} height={50} /> : null,
            flex: 0.6,
            // width: 80,
            headerAlign: "center",
            align: "center",
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'nome',
            headerName: 'ATLETA',
            editable: true,
            flex: 1,
            headerClassName: 'super-app-theme--header',
        },
        {
            field: 'min',
            type: 'number',
            headerName: 'Minutos',
            headerAlign: "center",
            align: "center",
            valueFormatter: ({ value }) => formatNumber(Number(value)),
            cellClassName: 'font-tabular-nums',
            editable: false,
            flex: 0.6,
            // width: 80,
            headerClassName: 'super-app-theme--header',
            sortable: false,
            disableColumnMenu: true,
        }
    ];

    function formatNumber(number = 0) {
        // this puts commas into the number eg 1000 goes to 1,000,
        // i pulled this from stack overflow, i have no idea how it works
        let valor = Math.floor(number).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,$2");
        return valor
    }

    listaStatsHeader.map(m => columns.push({
        field: m.stats.toString().toLocaleLowerCase(),
        headerName: m.stats.toString().toUpperCase(),
        editable: false,
        flex: 0.5,
        headerClassName: 'super-app-theme--header',
        valueFormatter: ({ value }) => (m.stats.toString().toUpperCase() === "FGMP"
            || m.stats.toString().toUpperCase() === "FTMP"
            || m.stats.toString().toUpperCase() === "THREEPMP" ? value.toFixed(3) : value),
        align: "center",
        headerAlign: "center",
        sortable: false,
        disableColumnMenu: true,

    }));

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(-1) : navigate(redirecionar);
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            fontSize: UtilidadeService.isMobile() ? 10 : 14,
            padding: UtilidadeService.isMobile() ? "5px" : "5px",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: UtilidadeService.isMobile() ? 10 : 14,
            padding: UtilidadeService.isMobile() ? "5px" : "5px",
            fontWeight: "bold"

        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            fontSize: UtilidadeService.isMobile() ? 10 : 14,
            padding: UtilidadeService.isMobile() ? "8px 5px" : "8px 5px",
            fontWeight: "bold"
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td': {
            border: 0,
        },
        '&:last-child th': {
            border: 0,
            padding: UtilidadeService.isMobile() ? "8px 5px" : "10px 8px",
        },
        '&:nth-of-type(odd):hover': {
            backgroundColor: "#fbc02d",
            fontWeight: "bold"
        },
        '&:nth-of-type(even):hover': {
            backgroundColor: "#fbc02d",
            fontWeight: "bold"
        },
    }));

    const handleVerificarValoresTabela = (valor: any) => {
        if (valor !== undefined && valor !== null) {
            return valor.toFixed(3).replace(".", ",");
        }
        return 0;
    }

    const handleExpandClick = (index: number, code: number) => {
        if (eval(`expanded${index}`)) {
            eval(`setEstatisticasMandanteRows${index}([])`);
            eval(`setEstatisticasVisitanteRows${index}([])`);
            eval(`setTotalCountJogadoresMandante${index}(0)`);
            eval(`setTotalCountJogadoresVisitante${index}(0)`);
        }
        eval(`setExpanded${index}(eval(!expanded${index}))`);

        JogadorService.getEstatisticasJogadorPorJogo(code)
            .then((result) => {
                setIsLoading(false);
                const obj = result.dado;
                setDadosEstatisticasJogo(obj);
                eval(`setEstatisticasMandanteRows${index}(obj.pontuacao_Jogadores_Franquia_Mandante)`);
                eval(`setEstatisticasVisitanteRows${index}(obj.pontuacao_Jogadores_Franquia_Visitante)`);
                eval(`setTotalCountJogadoresMandante${index}(obj.pontuacao_Jogadores_Franquia_Mandante.length)`);
                eval(`setTotalCountJogadoresVisitante${index}(obj.pontuacao_Jogadores_Franquia_Visitante.length)`);
            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });

    };

    useEffect(() => {
        const fetchData = async () => {
            await CalcularPontuacaoGeral();
        }
        fetchData();

    }, [placarMandante, placarVisitante])

    const CalcularPontuacaoGeral = async () => {
        let placarM = 0;
        let placarV = 0;

        jogadoresFranquiaMandante.filter(f => f.ordem === 1).slice(0, 1).map(m => {
            if (m.fgm !== null) {
                if (fgm_Mandante > fgm_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (fgm_Mandante < fgm_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }
            if (m.ftm !== null) {
                if (ftm_Mandante > ftm_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (ftm_Mandante < ftm_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.threepm !== null) {
                if (threepm_Mandante > threepm_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (threepm_Mandante < threepm_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.pts !== null) {
                if (pts_Mandante > pts_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (pts_Mandante < pts_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.reb !== null) {
                if (reb_Mandante > reb_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (reb_Mandante < reb_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.oreb !== null) {
                if (oreb_Mandante > oreb_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (oreb_Mandante < oreb_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.dreb !== null) {
                if (dreb_Mandante > dreb_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (dreb_Mandante < dreb_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.ast !== null) {
                if (ast_Mandante > ast_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (ast_Mandante < ast_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.stl !== null) {
                if (stl_Mandante > stl_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (stl_Mandante < stl_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.blk !== null) {
                if (blk_Mandante > blk_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (blk_Mandante < blk_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.to !== null) {
                if (to_Mandante < to_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (to_Mandante > to_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.pf !== null) {
                if (pf_Mandante < pf_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (pf_Mandante > pf_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.mplu !== null) {
                if (mplu_Mandante > mplu_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (mplu_Mandante < mplu_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.fgmp !== null) {
                if (porResFgmpMan > porResFgmpVis) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (porResFgmpMan < porResFgmpVis) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.threepmp !== null) {
                if (porResTreeMan > porResTreeVis) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (porResTreeMan < porResTreeVis) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.ftmp !== null) {
                if (porResFtmpMan > porResFtmpVis) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (porResFtmpMan < porResFtmpVis) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.fge !== null) {
                if (arremessos_Errados_Mandante > arremessos_Errados_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (arremessos_Errados_Mandante < arremessos_Errados_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.fte !== null) {
                if (lance_Livre_Errados_Mandante > lance_Livre_Errados_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (lance_Livre_Errados_Mandante < lance_Livre_Errados_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }

            if (m.threepe !== null) {
                if (tres_Pontos_Errados_Mandante > tres_Pontos_Errados_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (tres_Pontos_Errados_Mandante < tres_Pontos_Errados_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }
            if (m.stocks !== null) {
                if (stocks_Mandante > stocks_Visitante) {
                    placarM++;
                    setPlacarMandante(placarM);
                }
                else if (stocks_Mandante < stocks_Visitante) {
                    placarV++;
                    setPlacarVisitante(placarV);
                }
            }
        });
    }

    return (
        <LayoutBaseDePagina
            titulo={"Disputa de Playoffs"}// + nomeLiga}
            //showLogoImg={logoImage}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoNovo={false}
                    mostrarBotaoSalvar={false}
                    mostrarBotaoVoltar
                    aoClicarEmVoltar={() => navigate(`/liga/playoffs/${UtilidadeService.crypt((numeroRodada).toString())}`)}
                />
            }>
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                <Grid container direction="column" padding={2} spacing={3}>
                    <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" >
                        <Grid container size={{ xs: 12, sm: 12 }} paddingLeft={4} >
                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>CONFRONTO DE PLAYOFFS</Typography>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} paddingLeft={4} >
                            {!removeLoading && <Loading />}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }} display="flex" textAlign="center" justifyContent="center" >
                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 20 }}>
                                {statusJogo && vencedorMandante && (<Icon style={{ fontSize: UtilidadeService.isMobile() ? 12 : 19 }} color={"primary"}>emoji_events</Icon>)}&nbsp;&nbsp;
                            </Typography>
                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 13 : 20 }}>
                                <span style={{ fontSize: UtilidadeService.isMobile() ? 12 : 19, color: statusJogo && vencedorMandante ? "#00e676" : statusJogo && empate ? "#E46106" : "auto", fontWeight: "bold", }}>
                                    {nomeFranquiaMandante.toLocaleUpperCase()}
                                </span> {placarMandante} X {placarVisitante}
                                <span style={{ fontSize: UtilidadeService.isMobile() ? 12 : 19, color: statusJogo && vencedorVisitante ? "#00e676" : statusJogo && empate ? "#E46106" : "auto", fontWeight: "bold", }}>
                                    &nbsp;{nomeFranquiaVisitante.toLocaleUpperCase()}
                                </span>
                            </Typography>
                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 20 }}>
                                &nbsp;{statusJogo && vencedorVisitante && (<Icon style={{ fontSize: UtilidadeService.isMobile() ? 12 : 19 }} color={"primary"}>emoji_events</Icon>)}
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }} paddingTop={2}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}> {nomeFranquiaMandante}</Typography>
                            </Grid>
                            <TableContainer component={Paper} variant="outlined" sx={{ width: "auto" }}>
                                <Table >
                                    <TableHead >
                                        <StyledTableRow >
                                            <StyledTableCell align="center">FOTO</StyledTableCell>
                                            <StyledTableCell>NOME</StyledTableCell>
                                            <StyledTableCell>PG</StyledTableCell>
                                            <StyledTableCell>SG</StyledTableCell>
                                            <StyledTableCell>SF</StyledTableCell>
                                            <StyledTableCell>PF</StyledTableCell>
                                            <StyledTableCell>C</StyledTableCell>
                                            {jogadoresFranquiaMandante.find(f => f.min !== null) && <StyledTableCell align="center">{UtilidadeService.isMobile() ? "MIN" : "MINUTOS"}</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.fgm !== null) && <StyledTableCell align="center">FGM</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.ftm !== null) && <StyledTableCell align="center">FTM</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.threepm !== null) && <StyledTableCell align="center">3PM</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.pts !== null) && <StyledTableCell align="center">PTS</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.reb !== null) && <StyledTableCell align="center">REB</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.oreb !== null) && <StyledTableCell align="center">OREB</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.dreb !== null) && <StyledTableCell align="center">DREB</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.ast !== null) && <StyledTableCell align="center">AST</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.stl !== null) && <StyledTableCell align="center">STL</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.blk !== null) && <StyledTableCell align="center">BLK</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.to !== null) && <StyledTableCell align="center">TO</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.pf !== null) && <StyledTableCell align="center">PF</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.mplu !== null) && <StyledTableCell align="center">MPLU</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.fgmp !== null) && <StyledTableCell align="center">FG%</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.ftmp !== null) && <StyledTableCell align="center">FT%</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.threepmp !== null) && <StyledTableCell align="center">3P%</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.fge !== null) && <StyledTableCell align="center">FGE</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.fte !== null) && <StyledTableCell align="center">FTE</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.threepe !== null) && <StyledTableCell align="center">3PE</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.stocks !== null) && <StyledTableCell align="center">STKS</StyledTableCell>}
                                            {jogadoresFranquiaMandante.find(f => f.peso_Total_Jogador !== null) && <StyledTableCell align="center">PESO</StyledTableCell>}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {jogadoresFranquiaMandante.map((row, index) => (
                                            <StyledTableRow>
                                                <StyledTableCell align="center"><img src={row.foto} alt={row.nome} width={UtilidadeService.isMobile() ? 25 : 40} height={UtilidadeService.isMobile() ? 25 : 40} /></StyledTableCell>
                                                <StyledTableCell>{row.nome}</StyledTableCell>
                                                <StyledTableCell>{row.minutos_PG}</StyledTableCell>
                                                <StyledTableCell>{row.minutos_SG}</StyledTableCell>
                                                <StyledTableCell>{row.minutos_SF}</StyledTableCell>
                                                <StyledTableCell>{row.minutos_PF}</StyledTableCell>
                                                <StyledTableCell>{row.minutos_C}</StyledTableCell>
                                                {/* {row.quantidade_Jogos !== undefined && row.quantidade_Jogos !== null && <StyledTableCell align="center">{row.quantidade_Jogos}</StyledTableCell>} */}
                                                {row.min !== null && <StyledTableCell align="center">{Number(row.min).toFixed(0)}</StyledTableCell>}
                                                {row.fgm !== null && <StyledTableCell align="center">{row.fgm}</StyledTableCell>}
                                                {row.ftm !== null && <StyledTableCell align="center">{row.ftm}</StyledTableCell>}
                                                {row.threepm !== null && <StyledTableCell align="center">{row.threepm}</StyledTableCell>}
                                                {row.pts !== null && <StyledTableCell align="center">{row.pts}</StyledTableCell>}
                                                {row.reb !== null && <StyledTableCell align="center">{row.reb}</StyledTableCell>}
                                                {row.oreb !== null && <StyledTableCell align="center">{row.oreb}</StyledTableCell>}
                                                {row.dreb !== null && <StyledTableCell align="center">{row.dreb}</StyledTableCell>}
                                                {row.ast !== null && <StyledTableCell align="center">{row.ast}</StyledTableCell>}
                                                {row.stl !== null && <StyledTableCell align="center">{row.stl}</StyledTableCell>}
                                                {row.blk !== null && <StyledTableCell align="center">{row.blk}</StyledTableCell>}
                                                {row.to !== null && <StyledTableCell align="center">{row.to}</StyledTableCell>}
                                                {row.pf !== null && <StyledTableCell align="center">{row.pf}</StyledTableCell>}
                                                {row.mplu !== null && <StyledTableCell align="center">{row.mplu}</StyledTableCell>}
                                                {row.fgmp !== null && <StyledTableCell align="center">{(row.fgmp)?.toFixed(3)}</StyledTableCell>}
                                                {row.ftmp !== null && <StyledTableCell align="center">{(row.ftmp)?.toFixed(3)}</StyledTableCell>}
                                                {row.threepmp !== null && <StyledTableCell align="center">{(row.threepmp)?.toFixed(3)}</StyledTableCell>}
                                                {row.fge !== null && <StyledTableCell align="center">{(row.fge)}</StyledTableCell>}
                                                {row.fte !== null && <StyledTableCell align="center">{(row.fte)}</StyledTableCell>}
                                                {row.threepe !== null && <StyledTableCell align="center">{(row.threepe)}</StyledTableCell>}
                                                {row.stocks !== null && <StyledTableCell align="center">{(row.stocks)}</StyledTableCell>}
                                                {row.peso_Total_Jogador !== null && <StyledTableCell align="center">{(row.peso_Total_Jogador)}</StyledTableCell>}
                                            </StyledTableRow>
                                        ))
                                        }
                                    </TableBody>
                                    <TableFooter>
                                        {isLoading && (
                                            <TableRow>
                                                <TableCell colSpan={100}>
                                                    <LinearProgress variant="indeterminate" />
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {(jogadoresFranquiaMandante.length > 0) && (
                                            //<StyledTableRow>
                                            //    {jogadoresFranquiaMandante.find(f => f.peso_Total_Jogador !== null) && <StyledTableCell colSpan={100} style={{ textAlign: "end" }}>{`TOTAL ${pesoTotalMandante}`}</StyledTableCell>}
                                            //</StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={2} style={{ textAlign: "center", paddingRight: "24px" }}></StyledTableCell>
                                                {jogadoresFranquiaMandante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalMandantePG.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaMandante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalMandanteSG.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaMandante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalMandanteSF.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaMandante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalMandantePF.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaMandante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalMandanteC.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaMandante.find(f => f.peso_Total_Jogador !== null) && <StyledTableCell colSpan={100} style={{ textAlign: "end", paddingRight: "24px" }}>{`TOTAL ${pesoTotalMandante.toFixed(2)}`}</StyledTableCell>}

                                            </StyledTableRow>
                                        )}
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }} paddingTop={2}>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>{nomeFranquiaVisitante}</Typography>
                            </Grid>
                            <TableContainer component={Paper} variant="outlined" sx={{ width: "auto" }}>
                                <Table >
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell align="center">FOTO</StyledTableCell>
                                            <StyledTableCell>NOME</StyledTableCell>
                                            <StyledTableCell align="center">PG</StyledTableCell>
                                            <StyledTableCell align="center">SG</StyledTableCell>
                                            <StyledTableCell align="center">SF</StyledTableCell>
                                            <StyledTableCell align="center">PF</StyledTableCell>
                                            <StyledTableCell align="center">C</StyledTableCell>
                                            {jogadoresFranquiaVisitante.find(f => f.min !== null) && <StyledTableCell align="center">{UtilidadeService.isMobile() ? "MIN" : "MINUTOS"}</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.fgm !== null) && <StyledTableCell align="center">FGM</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.ftm !== null) && <StyledTableCell align="center">FTM</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.threepm !== null) && <StyledTableCell align="center">3PM</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.pts !== null) && <StyledTableCell align="center">PTS</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.reb !== null) && <StyledTableCell align="center">REB</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.oreb !== null) && <StyledTableCell align="center">OREB</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.dreb !== null) && <StyledTableCell align="center">DREB</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.ast !== null) && <StyledTableCell align="center">AST</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.stl !== null) && <StyledTableCell align="center">STL</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.blk !== null) && <StyledTableCell align="center">BLK</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.to !== null) && <StyledTableCell align="center">TO</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.pf !== null) && <StyledTableCell align="center">PF</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.mplu !== null) && <StyledTableCell align="center">MPLU</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.fgmp !== null) && <StyledTableCell align="center">FG%</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.ftmp !== null) && <StyledTableCell align="center">FT%</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.threepmp !== null) && <StyledTableCell align="center">3P%</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.fge !== null) && <StyledTableCell align="center">FGE</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.fte !== null) && <StyledTableCell align="center">FTE</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.threepe !== null) && <StyledTableCell align="center">3PE</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.stocks !== null) && <StyledTableCell align="center">STKS</StyledTableCell>}
                                            {jogadoresFranquiaVisitante.find(f => f.peso_Total_Jogador !== null) && <StyledTableCell align="center">PESO</StyledTableCell>}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {jogadoresFranquiaVisitante.map((row, index) => (
                                            <StyledTableRow>
                                                <StyledTableCell align="center"><img src={row.foto} alt={row.nome} width={UtilidadeService.isMobile() ? 25 : 40} height={UtilidadeService.isMobile() ? 25 : 40} /></StyledTableCell>
                                                <StyledTableCell >{row.nome}</StyledTableCell>
                                                <StyledTableCell align="center">{row.minutos_PG}</StyledTableCell>
                                                <StyledTableCell align="center">{row.minutos_SG}</StyledTableCell>
                                                <StyledTableCell align="center">{row.minutos_SF}</StyledTableCell>
                                                <StyledTableCell align="center">{row.minutos_PF}</StyledTableCell>
                                                <StyledTableCell align="center">{row.minutos_C}</StyledTableCell>
                                                {row.min !== null && <StyledTableCell align="center">{Number(row.min).toFixed(0)}</StyledTableCell>}
                                                {row.fgm !== null && <StyledTableCell align="center">{(row.fgm)}</StyledTableCell>}
                                                {row.ftm !== null && <StyledTableCell align="center">{(row.ftm)}</StyledTableCell>}
                                                {row.threepm !== null && <StyledTableCell align="center">{(row.threepm)}</StyledTableCell>}
                                                {row.pts !== null && <StyledTableCell align="center">{(row.pts)}</StyledTableCell>}
                                                {row.reb !== null && <StyledTableCell align="center">{(row.reb)}</StyledTableCell>}
                                                {row.oreb !== null && <StyledTableCell align="center">{(row.oreb)}</StyledTableCell>}
                                                {row.dreb !== null && <StyledTableCell align="center">{(row.dreb)}</StyledTableCell>}
                                                {row.ast !== null && <StyledTableCell align="center">{(row.ast)}</StyledTableCell>}
                                                {row.stl !== null && <StyledTableCell align="center">{(row.stl)}</StyledTableCell>}
                                                {row.blk !== null && <StyledTableCell align="center">{(row.blk)}</StyledTableCell>}
                                                {row.to !== null && <StyledTableCell align="center">{(row.to)}</StyledTableCell>}
                                                {row.pf !== null && <StyledTableCell align="center">{(row.pf)}</StyledTableCell>}
                                                {row.mplu !== null && <StyledTableCell align="center">{(row.mplu)}</StyledTableCell>}
                                                {row.fgmp !== null && <StyledTableCell align="center">{(row.fgmp)?.toFixed(3)}</StyledTableCell>}
                                                {row.ftmp !== null && <StyledTableCell align="center">{(row.ftmp)?.toFixed(3)}</StyledTableCell>}
                                                {row.threepmp !== null && <StyledTableCell align="center">{(row.threepmp)?.toFixed(3)}</StyledTableCell>}
                                                {row.fge !== null && <StyledTableCell align="center">{(row.fge)}</StyledTableCell>}
                                                {row.fte !== null && <StyledTableCell align="center">{(row.fte)}</StyledTableCell>}
                                                {row.threepe !== null && <StyledTableCell align="center">{(row.threepe)}</StyledTableCell>}
                                                {row.stocks !== null && <StyledTableCell align="center">{(row.stocks)}</StyledTableCell>}
                                                {row.peso_Total_Jogador !== null && <StyledTableCell align="center">{(row.peso_Total_Jogador)}</StyledTableCell>}
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                    <TableFooter>
                                        {isLoading && (
                                            <TableRow>
                                                <TableCell colSpan={100}>
                                                    <LinearProgress variant="indeterminate" />
                                                </TableCell>
                                            </TableRow>
                                        )}
                                        {(jogadoresFranquiaVisitante.length > 0) && (
                                            //<StyledTableRow>
                                            //    {jogadoresFranquiaVisitante.find(f => f.peso_Total_Jogador !== null) && <StyledTableCell colSpan={100} style={{ textAlign: "end" }}>{`TOTAL   ${pesoTotalVisitante}`}</StyledTableCell>}
                                            //</StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={2} style={{ textAlign: "center", paddingRight: "24px" }}></StyledTableCell>
                                                {jogadoresFranquiaVisitante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalVisitantePG.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaVisitante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalVisitanteSG.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaVisitante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalVisitanteSF.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaVisitante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalVisitantePF.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaVisitante.find(f => f.minutos_PG !== null) && <StyledTableCell style={{ paddingRight: "24px" }}>{totalVisitanteC.toFixed(0)}</StyledTableCell>}
                                                {jogadoresFranquiaVisitante.find(f => f.peso_Total_Jogador !== null) && <StyledTableCell colSpan={100} style={{ textAlign: "end", paddingRight: "24px" }}>{`TOTAL ${pesoTotalVisitante.toFixed(2)}`}</StyledTableCell>}

                                            </StyledTableRow>
                                        )}
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        </Grid>
                        {lstCriteriosDesempate.length > 0 &&
                            <Grid size={{ xs: 12, sm: 12 }} paddingTop={2} paddingBottom={2}>
                                <Grid size={{ xs: 12, sm: 12 }} >
                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 16 : 18 }}>CRITÉRIO DE DESEMPATE</Typography>
                                    <hr />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 12 }}>
                                    <Box sx={{
                                        height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                        '& .super-app-theme--header': {
                                            backgroundColor: theme.palette.common.black,
                                            color: theme.palette.common.white,
                                        },
                                        '& .super-app.negative': {
                                            color: 'red',
                                            fontWeight: 'bold'
                                        },
                                        '& .super-app.positive': {
                                            color: themeName === "light" ? "black" : "auto",
                                        },
                                    }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.codigo}
                                            rows={lstCriteriosDesempate}
                                            columns={columnsCriterioDesempate}
                                            disableRowSelectionOnClick
                                            disableColumnFilter
                                            disableColumnMenu
                                            hideFooter={true}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 12 : 14,
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        }
                        <Grid size={{ xs: 12, sm: 12 }} paddingLeft={4} >
                            <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 18 }}>JOGOS DA RODADA NBA</Typography>
                            <hr />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }} paddingLeft={4} >
                            {!removeLoading && <Loading />}
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="flex-start" >
                            {lstJogosRodadaNba.length > 0 &&
                                (
                                    lstJogosRodadaNba.map((m, i) => (
                                        <Grid container key={i} size={{ xs: 12, sm: 12 }} display="flex" justifyContent="flex-start" >
                                            <Card key={`Card${i}`} sx={{ width: "100%", boxShadow: "4", marginBottom: "5px" }}>
                                                <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="flex-start"  >
                                                    <Grid size={{ xs: 10, sm: 11 }} display="flex" justifyContent="flex-start" alignSelf={"center"}>
                                                        <CardActionArea onClick={() => handleExpandClick(i, m.codigo)}>
                                                            <CardContent sx={{ padding: 1, paddingBottom: 1 }}  >
                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                                                                    <Grid container size={{ xs: 12, sm: 2, md: 2, lg: 2, xl: 2 }} display="flex" justifyContent="flex-start"  >
                                                                        <Grid size={{ xs: 12, sm: 12 }} display="flex" justifyContent="flex-start" alignSelf={"center"}>
                                                                            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 16, paddingBottom: 1, fontWeight: 600 }}>{m.data_Inicio !== null ? m.data_Inicio.toString() : ""}</Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container size={{ xs: 12, sm: 10, md: 10, lg: 10, xl: 10 }} display="flex" justifyContent="center"  >
                                                                        <Grid size={{ xs: 3, sm: 3 }} display="flex" justifyContent="end" alignSelf={"center"}>
                                                                            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 18, }}>
                                                                                <span style={{
                                                                                    opacity: !m.mandante_Valido ? "0.7" : "1",
                                                                                    color: !m.mandante_Valido ? "#fbc02d" : "auto"
                                                                                }}>
                                                                                    {m.nome_Franquia_NBA_Mandante}
                                                                                </span>
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid size={{ xs: 2, sm: 2 }} display="flex" justifyContent="center" alignSelf={"center"}>
                                                                            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 18, paddingRight: '5px' }}>
                                                                                <img src={m.logo_Franquia_NBA_Mandante} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid size={{ xs: 2, sm: 2 }} display="flex" justifyContent="center" alignSelf="center">
                                                                            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 18, color: m.placar_Mandante > m.placar_Visitante ? "#00e676" : "auto", fontWeight: "bold" }}>
                                                                                {m.placar_Mandante}
                                                                            </Typography>
                                                                            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 18, fontWeight: 600 }}>
                                                                                &nbsp;X&nbsp;
                                                                            </Typography>
                                                                            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 18, color: m.placar_Mandante < m.placar_Visitante ? "#00e676" : "auto", fontWeight: "bold" }}>
                                                                                {m.placar_Visitante}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid size={{ xs: 2, sm: 2 }} display="flex" justifyContent="center" alignSelf={"center"}>
                                                                            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 10 : 18, }}>
                                                                                <img src={m.logo_Franquia_NBA_Visitante} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 50} />
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid size={{ xs: 3, sm: 3 }} display="flex" justifyContent="flex-start" alignSelf={"center"}>
                                                                            <Typography sx={{ fontSize: UtilidadeService.isMobile() ? 11 : 18, }}>
                                                                                <span style={{
                                                                                    opacity: !m.visitante_Valido ? "0.7" : "1",
                                                                                    color: !m.visitante_Valido ? "#fbc02d" : "auto", paddingLeft: '5px'
                                                                                }}>
                                                                                    {m.nome_Franquia_NBA_Visitante}
                                                                                </span>
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </CardContent>
                                                        </CardActionArea>
                                                    </Grid>
                                                    <Grid size={{ xs: 2, sm: 1 }} display="flex" justifyContent="flex-start" alignSelf={"center"}>
                                                        <CardActions disableSpacing >
                                                            <ExpandMore
                                                                key={m.codigo}
                                                                expand={eval(`expanded${i}`)}
                                                                onClick={() => handleExpandClick(i, m.codigo)}
                                                                aria-expanded={eval(`expanded${i}`)}
                                                                aria-label="Box Score"
                                                            >
                                                                <GridExpandMoreIcon sx={{ fontSize: UtilidadeService.isMobile() ? 16 : "auto", }} />
                                                            </ExpandMore>
                                                        </CardActions>
                                                    </Grid>
                                                </Grid>
                                                <Collapse in={eval(`expanded${i}`)} timeout="auto" unmountOnExit>
                                                    <CardContent>
                                                        <Grid container size={{ xs: 12, sm: 12 }}   >
                                                            <Grid size={{ xs: 12, sm: 12 }} padding={0}  >
                                                                <Typography paragraph sx={{ fontSize: UtilidadeService.isMobile() ? 12 : 18, paddingTop: 2, fontWeight: 600 }}>ESTATÍSTICAS DOS JOGADORES NBA MANDANTE</Typography>
                                                                <TableContainer component={Paper} variant="outlined" sx={{ width: "330", height: "600" }}>
                                                                    <Table>
                                                                        <TableHead sx={{ padding: UtilidadeService.isMobile() ? "5px" : "10px" }}>
                                                                            <TableRow>
                                                                                <StyledTableCell>Foto</StyledTableCell>
                                                                                <StyledTableCell>Nome</StyledTableCell>
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.minutos !== null) && <StyledTableCell align="center">{UtilidadeService.isMobile() ? "MIN" : "MINUTOS"}</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.arremessos !== null) && <StyledTableCell align="center">FGM</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.lance_Livre !== null) && <StyledTableCell align="center">FTM</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.tres_Pontos !== null) && <StyledTableCell align="center">3PM</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.pontos !== null) && <StyledTableCell align="center">PTS</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.rebotes !== null) && <StyledTableCell align="center">REB</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.rebotes_Ofensivos !== null) && <StyledTableCell align="center">OREB</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.rebotes_Defensivos !== null) && <StyledTableCell align="center">DREB</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.assistencias !== null) && <StyledTableCell align="center">AST</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.steal !== null) && <StyledTableCell align="center">STL</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.bloqueios !== null) && <StyledTableCell align="center">BLK</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.turnovers !== null) && <StyledTableCell align="center">TO</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.faltas !== null) && <StyledTableCell align="center">PF</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.min_Plus !== null) && <StyledTableCell align="center">MPLU</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.porcentagem_Arremessos !== null) && <StyledTableCell align="center">FG%</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.porcentagem_Lance_Livre !== null) && <StyledTableCell align="center">FT%</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.porcentagem_Tres_Pontos !== null) && <StyledTableCell align="center">3P%</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.arremessos_Errados !== null) && <StyledTableCell align="center">FGE</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.lance_Livre_Errados !== null) && <StyledTableCell align="center">FTE</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.tres_Pontos_Errados !== null) && <StyledTableCell align="center">threepe</StyledTableCell>}
                                                                                {eval(`estatisticasMandanteRows${i}`).find((f: IDadosEstatisticas) => f.stocks !== null) && <StyledTableCell align="center">STOCKS</StyledTableCell>}

                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {eval(`estatisticasMandanteRows${i}`).map((row: IDadosEstatisticas) => (
                                                                                <StyledTableRow key={row.codigo} >
                                                                                    <StyledTableCell><img src={row.foto} alt={row.nome} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} /></StyledTableCell>
                                                                                    <StyledTableCell>{row.nome}</StyledTableCell>
                                                                                    {row.minutos !== null && <StyledTableCell align="center">{row.minutos.toFixed(0)}</StyledTableCell>}
                                                                                    {row.arremessos !== null && <StyledTableCell align="center">{(row.arremessos)}</StyledTableCell>}
                                                                                    {row.lance_Livre !== null && <StyledTableCell align="center">{(row.lance_Livre)}</StyledTableCell>}
                                                                                    {row.tres_Pontos !== null && <StyledTableCell align="center">{(row.tres_Pontos)}</StyledTableCell>}
                                                                                    {row.pontos !== null && <StyledTableCell align="center">{(row.pontos)}</StyledTableCell>}
                                                                                    {row.rebotes !== null && <StyledTableCell align="center">{(row.rebotes)}</StyledTableCell>}
                                                                                    {row.rebotes_Ofensivos !== null && <StyledTableCell align="center">{(row.rebotes_Ofensivos)}</StyledTableCell>}
                                                                                    {row.rebotes_Defensivos !== null && <StyledTableCell align="center">{(row.rebotes_Defensivos)}</StyledTableCell>}
                                                                                    {row.assistencias !== null && <StyledTableCell align="center">{(row.assistencias)}</StyledTableCell>}
                                                                                    {row.steal !== null && <StyledTableCell align="center">{(row.steal)}</StyledTableCell>}
                                                                                    {row.bloqueios !== null && <StyledTableCell align="center">{(row.bloqueios)}</StyledTableCell>}
                                                                                    {row.turnovers !== null && <StyledTableCell align="center">{(row.turnovers)}</StyledTableCell>}
                                                                                    {row.faltas !== null && <StyledTableCell align="center">{(row.faltas)}</StyledTableCell>}
                                                                                    {row.min_Plus !== null && <StyledTableCell align="center">{(row.min_Plus)}</StyledTableCell>}
                                                                                    {row.porcentagem_Arremessos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.porcentagem_Arremessos)}</StyledTableCell>}
                                                                                    {row.porcentagem_Lance_Livre !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.porcentagem_Lance_Livre)}</StyledTableCell>}
                                                                                    {row.porcentagem_Tres_Pontos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.porcentagem_Tres_Pontos)}</StyledTableCell>}
                                                                                    {row.arremessos_Errados !== null && <StyledTableCell align="center">{(row.arremessos_Errados)}</StyledTableCell>}
                                                                                    {row.lance_Livre_Errados !== null && <StyledTableCell align="center">{(row.lance_Livre_Errados)}</StyledTableCell>}
                                                                                    {row.tres_Pontos_Errados !== null && <StyledTableCell align="center">{(row.tres_Pontos_Errados)}</StyledTableCell>}
                                                                                    {row.stocks !== null && <StyledTableCell align="center">{(row.stocks)}</StyledTableCell>}
                                                                                </StyledTableRow >
                                                                            ))
                                                                            }
                                                                        </TableBody>
                                                                        {eval(`totalCountJogadoresMandante${i}`) === 0 && !isLoading && (
                                                                            <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                                        )}
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} padding={0}  >
                                                                <Typography paragraph sx={{ fontSize: UtilidadeService.isMobile() ? 12 : 18, paddingTop: 2, fontWeight: 600 }}>ESTATÍSTICAS DOS JOGADORES NBA VISITANTE</Typography>
                                                                <TableContainer component={Paper} variant="outlined" sx={{ width: "330", height: "600" }}>
                                                                    <Table>
                                                                        <TableHead sx={{ padding: UtilidadeService.isMobile() ? "5px" : "10px" }}>
                                                                            <TableRow>
                                                                                <StyledTableCell>Foto</StyledTableCell>
                                                                                <StyledTableCell>Nome</StyledTableCell>
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.minutos !== null) && <StyledTableCell align="center">Minutos</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.arremessos !== null) && <StyledTableCell align="center">FGM</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.lance_Livre !== null) && <StyledTableCell align="center">FTM</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.tres_Pontos !== null) && <StyledTableCell align="center">3PM</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.pontos !== null) && <StyledTableCell align="center">PTS</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.rebotes !== null) && <StyledTableCell align="center">REB</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.rebotes_Ofensivos !== null) && <StyledTableCell align="center">OREB</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.rebotes_Defensivos !== null) && <StyledTableCell align="center">DREB</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.assistencias !== null) && <StyledTableCell align="center">AST</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.steal !== null) && <StyledTableCell align="center">STL</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.bloqueios !== null) && <StyledTableCell align="center">BLK</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.turnovers !== null) && <StyledTableCell align="center">TO</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.faltas !== null) && <StyledTableCell align="center">PF</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.min_Plus !== null) && <StyledTableCell align="center">MPLU</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.porcentagem_Arremessos !== null) && <StyledTableCell align="center">FG%</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.porcentagem_Lance_Livre !== null) && <StyledTableCell align="center">FT%</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.porcentagem_Tres_Pontos !== null) && <StyledTableCell align="center">3P%</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.arremessos_Errados !== null) && <StyledTableCell align="center">FGE</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.lance_Livre_Errados !== null) && <StyledTableCell align="center">FTE</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.tres_Pontos_Errados !== null) && <StyledTableCell align="center">threepe</StyledTableCell>}
                                                                                {eval(`estatisticasVisitanteRows${i}`).find((f: IDadosEstatisticas) => f.stocks !== null) && <StyledTableCell align="center">STOCKS</StyledTableCell>}
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {eval(`estatisticasVisitanteRows${i}`).map((row: IDadosEstatisticas) => (
                                                                                <StyledTableRow key={row.codigo} >
                                                                                    <StyledTableCell><img src={row.foto} alt={row.nome} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} /></StyledTableCell>
                                                                                    <StyledTableCell>{row.nome}</StyledTableCell>
                                                                                    {row.minutos !== null && <StyledTableCell align="center">{row.minutos.toFixed(0)}</StyledTableCell>}
                                                                                    {row.arremessos !== null && <StyledTableCell align="center">{(row.arremessos)}</StyledTableCell>}
                                                                                    {row.lance_Livre !== null && <StyledTableCell align="center">{(row.lance_Livre)}</StyledTableCell>}
                                                                                    {row.tres_Pontos !== null && <StyledTableCell align="center">{(row.tres_Pontos)}</StyledTableCell>}
                                                                                    {row.pontos !== null && <StyledTableCell align="center">{(row.pontos)}</StyledTableCell>}
                                                                                    {row.rebotes !== null && <StyledTableCell align="center">{(row.rebotes)}</StyledTableCell>}
                                                                                    {row.rebotes_Ofensivos !== null && <StyledTableCell align="center">{(row.rebotes_Ofensivos)}</StyledTableCell>}
                                                                                    {row.rebotes_Defensivos !== null && <StyledTableCell align="center">{(row.rebotes_Defensivos)}</StyledTableCell>}
                                                                                    {row.assistencias !== null && <StyledTableCell align="center">{(row.assistencias)}</StyledTableCell>}
                                                                                    {row.steal !== null && <StyledTableCell align="center">{(row.steal)}</StyledTableCell>}
                                                                                    {row.bloqueios !== null && <StyledTableCell align="center">{(row.bloqueios)}</StyledTableCell>}
                                                                                    {row.turnovers !== null && <StyledTableCell align="center">{(row.turnovers)}</StyledTableCell>}
                                                                                    {row.faltas !== null && <StyledTableCell align="center">{(row.faltas)}</StyledTableCell>}
                                                                                    {row.min_Plus !== null && <StyledTableCell align="center">{(row.min_Plus)}</StyledTableCell>}
                                                                                    {row.porcentagem_Arremessos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.porcentagem_Arremessos)}</StyledTableCell>}
                                                                                    {row.porcentagem_Lance_Livre !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.porcentagem_Lance_Livre)}</StyledTableCell>}
                                                                                    {row.porcentagem_Tres_Pontos !== null && <StyledTableCell align="center">{handleVerificarValoresTabela(row.porcentagem_Tres_Pontos)}</StyledTableCell>}
                                                                                    {row.arremessos_Errados !== null && <StyledTableCell align="center">{(row.arremessos_Errados)}</StyledTableCell>}
                                                                                    {row.lance_Livre_Errados !== null && <StyledTableCell align="center">{(row.lance_Livre_Errados)}</StyledTableCell>}
                                                                                    {row.tres_Pontos_Errados !== null && <StyledTableCell align="center">{(row.tres_Pontos_Errados)}</StyledTableCell>}
                                                                                    {row.stocks !== null && <StyledTableCell align="center">{(row.stocks)}</StyledTableCell>}

                                                                                </StyledTableRow >
                                                                            ))
                                                                            }
                                                                        </TableBody>
                                                                        {eval(`totalCountJogadoresVisitante${i}`) === 0 && !isLoading && (
                                                                            <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                                                                        )}
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Collapse>
                                            </Card>
                                        </Grid>
                                    ))
                                )}
                        </Grid>
                    </Grid>
                </Grid>
            </Box >
        </LayoutBaseDePagina >
    );
};